module.exports = __webpack_public_path__ + "static/media/Bravecto_Advantage_Club_2.0__SAMPLE_Terms_and_Conditions_-_Traduzido_(002).8c8cdb90.pdf";